import { render, staticRenderFns } from "./BaseRowActionsMenu.vue?vue&type=template&id=63da8d39"
import script from "./BaseRowActionsMenu.vue?vue&type=script&lang=js"
export * from "./BaseRowActionsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports